import { useCallback, useEffect, useMemo, useRef } from 'react'

import {
  IKeyboardContextRegisterResult,
  IKeyboardContextValue,
  IKeyboardEvent,
} from 'core-components/wrappers/keyboard'

interface IUseKeysSettings {
  useHotKeys: boolean
}

export const useKeysSettings = ({ useHotKeys }: IUseKeysSettings) => {
  const keyboardRef = useRef<IKeyboardContextRegisterResult | null>(null)

  const keysSettings = useMemo(() => {
    return [
      {
        key: 'ArrowDown',
        fn: () => {
          // immutable.current = immutable.next
          // setFocusOn(immutable.next)
        },
      },
      {
        key: 'ArrowUp',
        fn: () => {
          // immutable.current = immutable.prev
          // setFocusOn(immutable.prev)
        },
      },
      {
        key: 'Enter',
        fn: () => {
          // const focusedItem = immutable.enterClick[immutable.current]
          // focusedItem && focusedItem.rowClick()
        },
      },
    ] as IKeyboardEvent[]
  }, [])

  const registerKeyboardEvent = useCallback(
    (keyboardContext: IKeyboardContextValue) => {
      if (useHotKeys) {
        keyboardRef.current = keyboardContext.registr(keysSettings)
      }
    },
    [useHotKeys, keysSettings]
  )

  const prioritizeKeyboard = useCallback(() => {
    keyboardRef.current?.priorifize()
  }, [])

  useEffect(() => {
    return keyboardRef.current?.unregistr()
  })

  return { registerKeyboardEvent, prioritizeKeyboard }
}
